/**
 * Simple token service that manages OAuth tokens in sessionStorage
 */
class TokenService {
  private readonly TOKEN_KEY = 'oauth_access_token';

  /**
   * Get stored token from sessionStorage
   */
  getStoredToken(): string | null {
    return sessionStorage.getItem(this.TOKEN_KEY);
  }

  /**
   * Store token in sessionStorage
   */
  storeToken(token: string): void {
    sessionStorage.setItem(this.TOKEN_KEY, token);
  }

  /**
   * Remove token from sessionStorage
   */
  clearToken(): void {
    sessionStorage.removeItem(this.TOKEN_KEY);
  }

  /**
   * Check if token exists (basic check)
   */
  isTokenValid(): boolean {
    const token = this.getStoredToken();
    return token !== null && token.length > 0;
  }
}

export const tokenService = new TokenService();
